import React from 'react';
import NoFormTable from '../../components/customTable/NoFormTable';
import {t, getLanguage} from 'react-switch-lang';
import {format, parseISO} from 'date-fns';

const DeletedRisk = () => {
  const lang = getLanguage();
  const columns = [
    {
      key: 'id',
      dataIndex: 'id',
      title: t('last-risks-by-status-verified.riskId'),
      ellipsis: true,
    },
    {
      key: 'title',
      dataIndex: 'title',
      title: t('last-risks-by-status-verified.riskName'),
      ellipsis: true,
    },
    {
      key: 'riskTypeName',
      dataIndex: 'riskTypeName',
      title: t('last-risks-by-status-verified.riskTypeName'),
      ellipsis: true,
    },
    {
      key: 'riskStatusName',
      dataIndex: lang === 'mne' ? 'riskStatusName' : 'riskStatusNameEn',
      title: t('last-risks-by-status-verified.riskStatusName'),
      ellipsis: true,
    },
    {
      key: 'applicationDate',
      dataIndex: 'applicationDate',
      title: t('last-risks-by-status-verified.creationDate'),
      ellipsis: true,
      render: (dataIndex) => (
        <span> {format(parseISO(dataIndex), 'dd.MM.yyyy.')}</span>
      ),
    },
    {
      key: 'value',
      title: t('last-potential-incurred.userCreated'),
      render: (request) => {
        return `${request.userCreatedFirstName} ${request.userCreatedLastName}`;
      },
    },
  ];

  const onRowClick = () => {};

  return (
    <div className="h-100 w-100 administration-template">
      <NoFormTable
        api="/risks/deleted-risks/"
        columns={columns}
        onClick={onRowClick}
      />
    </div>
  );
};

export default DeletedRisk;
